import { createSlice } from "@reduxjs/toolkit";
import { endOfDay, subDays } from "date-fns";
const initialState = {
    chatbot: null,
    messageSender: undefined,
    ratings: [],
    reviewMessageStart: subDays(new Date(), 7),
    reviewMessageEnd: endOfDay(new Date()),
};
const answerReviewsSlice = createSlice({
    name: "answerReviews",
    initialState,
    reducers: {
        setChatbot(state, action) {
            state.chatbot = action.payload;
        },
        setMessageSender(state, action) {
            state.messageSender = action.payload;
        },
        setRating(state, action) {
            state.ratings = action.payload;
        },
        setReviewMessageStart(state, { payload }) {
            state.reviewMessageStart = payload;
        },
        setReviewMessageStop(state, { payload }) {
            state.reviewMessageEnd = payload;
        },
    },
});
export const { setChatbot, setMessageSender, setRating, setReviewMessageStart, setReviewMessageStop } = answerReviewsSlice.actions;
export default answerReviewsSlice.reducer;
export const answerReviewsSelector = (state) => state.answerReviews;
